export default class Video {
  constructor(element) {
    this.passedElement = element;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      // console.log("init video");
      this.getElements();
      this._addEventListeners();

      // Add heights as properties so can smoothly transition
      this.nameHeight = this.name.clientHeight;
      this.fundHeight = this.fund.clientHeight;
      this.imageHeight = this.image.clientHeight;

      // this.name.style.height = `${this.nameHeight}px`;
      // this.fund.style.height = `${this.fundHeight}px`;
      // this.image.style.height = `${this.imageHeight}px`;
    }
  }

  getElements = () => {
    // console.log("Get elements");
    this.image = document.querySelector(".js-manager-image");
    this.video = document.querySelector(".js-video");
    this.playButton = document.querySelector(".js-play");
    this.volumeButton = document.querySelector(".js-volume");
    this.closeButtonContainer = document.querySelector(".js-close-container");
    this.closeButton = document.querySelector(".js-close");
    this.name = document.querySelector(".rf-manager-header__name");
    this.fund = document.querySelector(".rf-manager-header__fund");
  }

  handlePlayClick = () => {
    // console.log("play");
    this.hidePhoto();
    this.hideNameAndFund();
    this.showVideo();
  }

  handleCloseClick = () => {
    // console.log("close");
    this.closeVideo();
    this.showNameAndFund();
    this.showPhoto();
  }

  _addEventListeners = () => {
    this.playButton.addEventListener('click', this.handlePlayClick);
    this.closeButton.addEventListener('click', this.handleCloseClick);
  }

  _removeEventListeners = () => {}

  hidePhoto = () => {
    this.image.classList.add("hidden");
    setTimeout(() => {
      this.image.style.height = "0px";
    }, 300)
  }

  showPhoto = () => {
    this.image.style.height = "auto";
    // this.image.style.height = `${this.imageHeight}px`;
    setTimeout(() => {
      this.image.classList.remove("hidden");
    }, 300)
  }

  hideNameAndFund = () => {
    this.name.classList.add("hidden");
    this.fund.classList.add("hidden");

    setTimeout(() => {
      this.name.style.height = "0px";
      this.fund.style.height = "0px";
    }, 100)
  }

  showNameAndFund = () => {
    // Should probs be set on load to animate properly
    // this.name.style.height = `${this.nameHeight}px`;
    // this.fund.style.height = `${this.fundHeight}px`;
    this.name.style.height = "auto";
    this.fund.style.height = "auto";

    setTimeout(() => {
      this.name.classList.remove("hidden");
      this.fund.classList.remove("hidden");
    }, 300)
  }

  showVideo = () => {
    this.video.classList.add("show");
    setTimeout(() => {
      this.video.style.opacity = 1;
      this.closeButtonContainer.classList.add('show');
      this.video.play();
    }, 300);
  }

  closeVideo = () => {
    this.video.pause();
    this.closeButtonContainer.classList.remove('show');
    this.video.style.opacity = 0;

    this.video.classList.add("show");
    setTimeout(() => {
      this.video.classList.remove("show");
    }, 300);
  }


  dismantle = () => {
    this._removeEventListeners();
    this.initialised = false;
  }
}
